import { state } from "@/data/providers/global-provider";

import { python } from "@/platforms/python";
import { html } from "./html";
import { microbit } from "./microbit";
import { HTMLGenerator } from "./html/html-generator";

export let toolboxXML: string;

export async function getToolboxXml(): Promise<string> {
  toolboxXML = "<xml>";

  (await import("@/platforms/general/definitions")).default(Blockly.Blocks);
  (await import("@/platforms/general/generators")).default(
    Blockly.Python as any
  );

  switch (state.platform?.name) {
    case python.name:
      (await import("@/platforms/python/blocks/imports/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/python/blocks/imports/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/imports/toolbox.xml")
        .default;

      (await import("@/platforms/python/blocks/variables/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/python/blocks/variables/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/variables/toolbox.xml")
        .default;

      (
        await import("@/platforms/python/blocks/statements/definitions")
      ).default(Blockly.Blocks);
      (await import("@/platforms/python/blocks/statements/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/statements/toolbox.xml")
        .default;

      (await import("@/platforms/python/blocks/logic/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/python/blocks/logic/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/logic/toolbox.xml")
        .default;

      (await import("@/platforms/python/blocks/lists/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/python/blocks/lists/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/lists/toolbox.xml")
        .default;

      (await import("@/platforms/python/blocks/loops/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/python/blocks/loops/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/loops/toolbox.xml")
        .default;

      (
        await import("@/platforms/python/blocks/definitions/definitions")
      ).default(Blockly.Blocks);
      (
        await import("@/platforms/python/blocks/definitions/generators")
      ).default(Blockly.Python as any);
      toolboxXML += require("@/platforms/python/blocks/definitions/toolbox.xml")
        .default;

      (await import("@/platforms/python/blocks/math/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/python/blocks/math/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/math/toolbox.xml")
        .default;

      (await import("@/platforms/python/blocks/turtle/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/python/blocks/turtle/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/turtle/toolbox.xml")
        .default;

      (await import("@/platforms/python/blocks/graphs/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/python/blocks/graphs/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/graphs/toolbox.xml")
        .default;

      (await import("@/platforms/python/blocks/random/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/python/blocks/random/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/random/toolbox.xml")
        .default;

      (
        await import("@/platforms/python/blocks/processing/definitions")
      ).default(Blockly.Blocks);
      (await import("@/platforms/python/blocks/processing/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/processing/toolbox.xml")
        .default;

      (await import("@/platforms/python/blocks/requests/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/python/blocks/requests/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/python/blocks/requests/toolbox.xml")
        .default;
      break;

    case microbit.name:
      (await import("@/platforms/microbit/blocks/basic/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/microbit/blocks/basic/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/microbit/blocks/basic/toolbox.xml")
        .default;

      (
        await import("@/platforms/microbit/blocks/variables/definitions")
      ).default(Blockly.Blocks);
      (
        await import("@/platforms/microbit/blocks/variables/generators")
      ).default(Blockly.Python as any);
      toolboxXML += require("@/platforms/microbit/blocks/variables/toolbox.xml")
        .default;

      (await import("@/platforms/microbit/blocks/display/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/microbit/blocks/display/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/microbit/blocks/display/toolbox.xml")
        .default;

      (await import("@/platforms/microbit/blocks/buttons/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/microbit/blocks/buttons/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/microbit/blocks/buttons/toolbox.xml")
        .default;

      (
        await import("@/platforms/microbit/blocks/accelerometer/definitions")
      ).default(Blockly.Blocks);
      (
        await import("@/platforms/microbit/blocks/accelerometer/generators")
      ).default(Blockly.Python as any);
      toolboxXML += require("@/platforms/microbit/blocks/accelerometer/toolbox.xml")
        .default;

      (await import("@/platforms/microbit/blocks/compass/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/microbit/blocks/compass/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/microbit/blocks/compass/toolbox.xml")
        .default;

      (await import("@/platforms/microbit/blocks/radio/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/microbit/blocks/radio/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/microbit/blocks/radio/toolbox.xml")
        .default;

      (await import("@/platforms/microbit/blocks/speech/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/microbit/blocks/speech/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/microbit/blocks/speech/toolbox.xml")
        .default;

      (await import("@/platforms/microbit/blocks/music/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/microbit/blocks/music/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/microbit/blocks/music/toolbox.xml")
        .default;

      (
        await import("@/platforms/microbit/blocks/microphone/definitions")
      ).default(Blockly.Blocks);
      (
        await import("@/platforms/microbit/blocks/microphone/generators")
      ).default(Blockly.Python as any);
      toolboxXML += require("@/platforms/microbit/blocks/microphone/toolbox.xml")
        .default;

      (
        await import("@/platforms/microbit/blocks/neopixel/definitions")
      ).default(Blockly.Blocks);
      (await import("@/platforms/microbit/blocks/neopixel/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/microbit/blocks/neopixel/toolbox.xml")
        .default;

      (await import("@/platforms/microbit/blocks/pins/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/microbit/blocks/pins/generators")).default(
        Blockly.Python as any
      );
      toolboxXML += require("@/platforms/microbit/blocks/pins/toolbox.xml")
        .default;
      break;

    case html.name:
      (await import("@/platforms/html/blocks/page/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/html/blocks/page/generators")).default(
        HTMLGenerator as any
      );
      toolboxXML += require("@/platforms/html/blocks/page/toolbox.xml").default;

      (await import("@/platforms/html/blocks/structure/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/html/blocks/structure/generators")).default(
        HTMLGenerator as any
      );
      toolboxXML += require("@/platforms/html/blocks/structure/toolbox.xml").default;

      (await import("@/platforms/html/blocks/text/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/html/blocks/text/generators")).default(
        HTMLGenerator as any
      );
      toolboxXML += require("@/platforms/html/blocks/text/toolbox.xml").default;

      (await import("@/platforms/html/blocks/attributes/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/html/blocks/attributes/generators")).default(
        HTMLGenerator as any
      );
      toolboxXML += require("@/platforms/html/blocks/attributes/toolbox.xml").default;

      (await import("@/platforms/html/blocks/style/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/html/blocks/style/generators")).default(
        HTMLGenerator as any
      );
      toolboxXML += require("@/platforms/html/blocks/style/toolbox.xml").default;

      (await import("@/platforms/html/blocks/media/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/html/blocks/media/generators")).default(
        HTMLGenerator as any
      );
      toolboxXML += require("@/platforms/html/blocks/media/toolbox.xml").default;

      (await import("@/platforms/html/blocks/forms/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/html/blocks/forms/generators")).default(
        HTMLGenerator as any
      );
      toolboxXML += require("@/platforms/html/blocks/forms/toolbox.xml").default;

      (await import("@/platforms/html/blocks/tables/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/html/blocks/tables/generators")).default(
        HTMLGenerator as any
      );
      toolboxXML += require("@/platforms/html/blocks/tables/toolbox.xml").default;

      (await import("@/platforms/html/blocks/lists/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/html/blocks/lists/generators")).default(
        HTMLGenerator as any
      );
      toolboxXML += require("@/platforms/html/blocks/lists/toolbox.xml").default;

      (await import("@/platforms/html/blocks/script/definitions")).default(
        Blockly.Blocks
      );
      (await import("@/platforms/html/blocks/script/generators")).default(
        HTMLGenerator as any
      );
      toolboxXML += require("@/platforms/html/blocks/script/toolbox.xml").default;
      break;
  }

  toolboxXML += "</xml>";

  return toolboxXML;
}
